module.exports = __webpack_public_path__ + "1e885a913891d3e49d26dbdfd9406101.pdf";